import React, { Component } from 'react';

import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Typography from 'material-ui/Typography';

const styles = {
  root: {
    backgroundColor: '#546E7A',
    paddingLeft: '20%',
    paddingRight: '20%',
  }
}

function getStep(status) {
  switch (status) {
    case 'CONNECT':
    case 'registration check':
    case 'create socket':
      return 0;
    case 'creating settings':
    case 'sending settings':
    case 'answer received':
      return 1;
    case 'connection established':
    case 'downloading files...':
      return 2;
    case 'ok':
      return 3;
    default:
      return -1;
  }
}

// optional={<Err />}


function getInfo(connect, status, error) {
  const step = getStep(status);

  if (error) {
    return { step, error: true };
  }

  if (connect === false) {
    return { step: -1, error: false };
  }

  return { step, error: false };
}

const Err = () =>
  <Typography variant="caption" color="error">
    Alert message
  </Typography>

const Log = ({ connect, status, error }) => {
  const info = getInfo(connect, status, error);
  return (
    <Stepper style={styles.root} activeStep={info.step} orientation="horizontal">
     <Step>
       <StepLabel error={info.error && info.step === 0}>Connect</StepLabel>
     </Step>
     <Step>
       <StepLabel error={info.error && info.step === 1}>Settings</StepLabel>
     </Step>
     <Step>
       <StepLabel error={info.error && info.step === 2}>Download</StepLabel>
     </Step>
    </Stepper>
  );
}


export default Log;



// WEBPACK FOOTER //
// ./src/components/Log.js